import PageTitle from "../../../Components/UI/PageTitle";
import AddOrEditCourse from "../../../Components/CoursesModuleComponents/AddOrEditCourse";

const CreateNewCourse = () => {
  return (
    <>
      <PageTitle
        BreadcrumbItems={[
          { title: "Home", link: "/" },
          {
            title: "Courses Management",
            link: `/courses-management`,
          },
          { title: "Add New Course" },
        ]}
        title={"Add New Course"}
      />
      <AddOrEditCourse />
    </>
  );
};

export default CreateNewCourse;
